export default {
  login: {
    title: 'Connexion',
    error: {
      invalidEmail: 'E-mail invalide',
      invalidPassword: 'Mot de passe invalide',
      badCredentialsTitle: 'Mauvais identifiants',
      accountLockedTitle: 'L\'accès au compte a été bloqué',
      accountLockedCaption: 'Vous pouvez nous contacter à {contactEmail}',
      badCredentialsCaption: 'Veuillez vérifier votre e-mail et votre mot de passe.',
      tooManyAttemptsRetryAfter: 'Trop de tentatives. Veuillez réessayer dans {durationRemaining}.',
      tooManyAttempts: 'Trop de tentatives. Veuillez réessayer plus tard',
      unavailableIdentityProvider: 'La connexion par ce moyen d\'authentification est actuellement indisponible. Veuillez réessayer plus tard.'
    }
  },
  passwordRenewal: {
    title: 'Renouvellement de mot de passe',
    newPassword: 'Vous pouvez désormais saisir votre nouveau mot de passe de connexion',
    success: {
      title: 'Renouvellement de mot de passe réussi',
      message: 'Le mot de passe associé à votre compte a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
      redirect: 'Vous allez être redirigé sur la page demandée dans quelques secondes.',
      redirectButton: 'Redirection immédiate'
    },
    error: 'Le nouveau mot de passe doit être différent de l\'ancien'
  },
  forgotPassword: {
    title: 'Réinitialisation de mot de passe',
    subTitle: {
      email: 'Veuillez renseigner votre adresse électronique. Vous recevrez un code dans votre boite de réception vous permettant de réinitialiser votre mot de passe.',
      sms: 'Veuillez renseigner votre numéro de téléphone. Vous recevrez un code par sms vous permettant de réinitialiser votre mot de passe.'
    },
    useAnotherMethod: 'Utiliser une autre méthode',
    chooseEmail: 'Recevoir un code de récupération par e-mail',
    chooseSms: 'Recevoir un code de récupération par sms',
    newPassword: 'Vous pouvez désormais saisir votre nouveau mot de passe de connexion',
    codeSent: {
      email: 'Un e-mail contenant votre code vous a été envoyé. Veuillez le saisir dans les champs ci-dessous',
      sms: 'Un sms contenant votre code vous a été envoyé. Veuillez le saisir dans les champs ci-dessous'
    },
    tooManyTrials: 'Vous avez dépassé la limite d\'essais pour ce code. Veuillez renouveller l\'opération',
    success: {
      title: 'Changement de mot de passe réussi',
      message: 'Le mot de passe associé à votre compte a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
      redirect: 'Vous allez être redirigé sur le formulaire de connexion dans quelques secondes.'
    }
  },
  pendingStatus: {
    title: 'Compte en attente de validation',
    subTitle: 'Votre identité doit d\'abord être vérifiée avant que vous puissiez vous connecter.'
  },
  cgu: {
    label: 'Conditions générales d’utilisation',
    checkbox: 'J\'ai lu et j\'accepte les'
  },
  mfa: {
    title: 'Validation en deux étapes',
    helper: 'Par mesure de sécurité, une validation en deux étapes est requise pour pouvoir acceder à votre compte. Veuillez séléctionner un mode de vérification',
    chooseMail: 'Recevoir un code de validation à votre adresse e-mail ',
    choosePhone: 'Recevoir un code de validation par SMS au',
    smsSent: 'Un SMS contenant votre code vous a été envoyé au numéro {userSms} . Veuillez le saisir dans les champs ci-dessous',
    checkCode: 'Vérifier mon code',
    codeNoSend: 'Code non reçu',
    dontAsk: 'Ne plus me demander sur cet appareil'
  },
  emailValidation: {
    title: 'Vérification d\'E-mail',
    resend: 'Renvoyer un email',
    emailSent: 'Un e-mail contenant votre code vous a été envoyé à l\'adresse {userEmail} . Veuillez le saisir dans les champs ci-dessous'
  },
  mobilePhoneValidation: {
    title: 'Vérification de votre numéro de téléphone',
    willSendCode: 'Nous vous enverrons un code de validation par SMS pour nous assurer que ce numéro est bien le vôtre.',
    numberChanged: 'Le numéro de téléphone utilisé pour vous connecter a été modifié, voici le numéro qui a été renseigné :',
    codeSent: 'Un code SMS vous a été envoyé pour le valider. Veuillez le saisir ci-dessous.',
    checkPhoneNumber: 'Si ce numéro ne correspond pas à votre numéro de téléphone actuel, vous pouvez le modifier',
    updateMobilePhone: 'Modifier mon numéro de téléphone',
    invalidPhoneNumber: 'Le numéro de téléphone est invalide'
  },
  lockAccount: {
    lock: 'Bloquer mon compte',
    warning: 'Vous êtes sur le point de bloquer votre compte. Continuer ?',
    resend: 'Renvoyer un email',
    locked: 'Le compte a été bloqué. Vous allez être déconnecté'
  },
  register: {
    title: 'Inscription',
    subTitle: 'Formulaire d\'inscription',
    subTitlePatient: 'Formulaire d\'inscription patient',
    createNewAccount: 'Création d\'un nouveau compte',
    passwordConfirm: 'Confirmer le mot de passe',
    action: 'S\'inscrire',
    registerAs: 'S\'inscrire en tant que',
    error: {
      passwordConfirm: 'Les mots de passe doivent correspondre',
      emailAlreadyUsed: 'Cette addresse mail est déjà utilisée'
    },
    confirmation: {
      success: {
        title: 'Inscription réussie',
        message: 'Votre compte a été créé avec succès. Vous pouvez maintenant vous connecter.',
        redirect: 'Vous allez être redirigé sur le formulaire de connexion dans quelques secondes.'
      },
      error: {
        title: 'Inscription échouée',
        message: 'Une erreur est survenue lors de l\'inscription. Veuillez réessayer plus tard.'
      }
    }
  },
  code: {
    sent: 'Un nouveau code a été envoyé',
    incorrect: 'Code incorrect',
    expired: 'Le code a expiré.',
    invalid: 'Le code est invalide',
    alreadySent: 'Un code a déjà été envoyé récemment'
  },
  errors: {
    sessionExpired: {
      title: 'Votre session est expirée'
    },
    expiredLink: 'Le lien de connexion a expiré.'
  },
  firstLogin: {
    title: 'Définissez votre mot de passe',
    welcome: 'Bienvenue !',
    pendingLogin: 'Connexion à votre compte en cours...',
    resendCode: 'Code non reçu',
    newPassword: 'Vous pouvez à présent entrer votre mot de passe de connexion',
    success: {
      success: 'Connexion réussie !',
      title: 'Mot de passe créé avec succès',
      message: 'Le mot de passe associé à votre compte a été créé avec succès. Vous pouvez vous connecter avec ce mot de passe.',
      redirect: 'Vous allez être redirigé vers le formulaire de connexion dans quelques secondes.',
      redirectBack: 'Vous allez être redirigé vers la page demandée dans quelques secondes.'
    },
    error: {
      codeResent: 'Veuillez renseigner le code se sécurité que nous vous avons envoyé par email pour vous connecter.'
    }
  },
  biometrics: {
    login: {
      backToNormalLogin: 'Connexion classique'
    },
    error: {
      biometricsErrorCaptions: 'Une erreur est survenue lors de l\'identification',
      biometricsKeyInvalidated: 'Vos données biométriques sont périmées. Un nouvel enregistrement sera nécéssaire'
    },
    enroll: {
      enrollSuccessCaption: 'Ajout de la connexion par données biométriques',
      enrollErrorCaption: 'Un problème est survenu lors de l\'enregistrement des données biométriques',
      warning: 'En activant la connexion par biométriques, vous acceptez que toutes les empreintes enregistrées dans ce terminal mobile permettent l\'accès à votre profil et vos données personnelles',
      identificationText: 'Identification par',
      askQuestionPartOne: 'Souhaitez-vous pouvoir utiliser l\'identification par ',
      askQuestionPartTwo: ' pour les futures connexions ?'
    }
  }
}
